import React, { useEffect } from "react";
import { useScrollToTop } from "../components/hooks/scrollToTopHook";
import { useServices } from "../contexts/ServiceContext";
import { MyPicksView, PickHistory } from "../views/MyPicksView";
import { useApplication } from "../contexts/ApplicationContext";
import { FreeplayEvent } from "@freeplay/shared-code";

export const MyPicksController = (): JSX.Element => {
    const {
        appState: { playerEventHistory },
        appDispatch,
    } = useApplication();

    const { eventsApi, fpUser } = useServices();
    useScrollToTop();

    useEffect(() => {
        (async () => {
            const playerEventHistoryRes = await eventsApi.getEventHistory();
            appDispatch({ type: "setPlayerEventHistory", events: playerEventHistoryRes });
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!fpUser) {
            appDispatch({ type: "setLoginButtonVisible", buttonVisible: true, buttonString: "Login To Compete" });
        } else {
            appDispatch({ type: "setLoginButtonVisible", buttonVisible: false, buttonString: "" });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fpUser]);

    const showPicksOverview = async (event: FreeplayEvent) => {
        appDispatch({ type: "showEventView", eventId: event.id });
        appDispatch({ type: "setPageTitle", pageTitle: event.name });
    };

    const showHome = async () => {
        appDispatch({ type: "showHome" });
    };

    return (
        <MyPicksView
            fpUser={fpUser}
            playerEventHistory={playerEventHistory as PickHistory[]}
            showPicksOverview={showPicksOverview}
            showHome={showHome}
        ></MyPicksView>
    );
};
